import React from "react";
import { withRouter } from "react-router-dom";
import DIDListComponent from "./DIDListComponent";


const DIDListComponentLanding = () => {
  return <DIDListComponent />
};
export default withRouter(DIDListComponentLanding);